'use strict';
// @flow

import { combineReducers } from 'redux-immutable';

import lista from 'reducers/ferramentas/prestador/lista';
import detalhes from 'reducers/ferramentas/prestador/detalhes';

export default combineReducers({ lista, detalhes });
